'use client';

import { useEffect, useRef } from 'react';

import { CookiesNames } from '@/constants';
import { useCookies, useFulFillmentType } from '@/hooks';
import { FulfillmentType } from '@/types';

/**
 * Globally watches the selected fulfillment type and persists it to a cookie
 * so SSR (OpenSearch, product listings) can read it via getSelectedFulfillmentTypeFromServer.
 */
export const FulfillmentTypeCookieSync = () => {
  const { fulfillmentType } = useFulFillmentType();
  const { setCookieValue } = useCookies();
  const prevFulfillmentTypeRef = useRef<FulfillmentType | undefined>(undefined);

  useEffect(() => {
    if (!fulfillmentType) return;

    if (prevFulfillmentTypeRef.current === fulfillmentType) return;

    prevFulfillmentTypeRef.current = fulfillmentType;
    setCookieValue(CookiesNames._FULFILLMENT_TYPE, fulfillmentType);
  }, [fulfillmentType, setCookieValue]);

  return null;
};
